import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TipoLancamento } from '@models/tipo-lancamento';
import { MessageService } from '@services/message.service';
import { TransferirLancamentoService } from '@services/transferir-lancamento.service';

export interface TransferirLancamentoDialogData {
  lancamentoIds: number[];
  tiposLancamento?: TipoLancamento[];
  conciliacaoId?: number;
  tipoLancamentoIdAtual?: number;
}

@Component({
  selector: 'app-transferir-lancamento-dialog',
  standalone: false,
  templateUrl: './transferir-lancamento-dialog.component.html',
  styleUrl: './transferir-lancamento-dialog.component.scss',
})
export class TransferirLancamentoDialogComponent implements OnInit {

  readonly title = 'Alterar tipo do lançamento';

  tiposLancamento: TipoLancamento[] = [];
  tipoLancamento: TipoLancamento | undefined;

  private lancamentoIds: number[];
  private conciliacaoId: number | undefined;
  private tipoIdInicial: number | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: TransferirLancamentoDialogData,
    private transferirLancamentoService: TransferirLancamentoService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<TransferirLancamentoDialogComponent>,
  ) {
    this.lancamentoIds = data.lancamentoIds;
    this.conciliacaoId = data.conciliacaoId;
    this.tipoIdInicial = data.tipoLancamentoIdAtual;
  }

  ngOnInit(): void {
    if (this.data.tiposLancamento?.length) {
      this.tiposLancamento = this.data.tiposLancamento;
      this.preselecionarTipoAtual();
    } else {
      this.transferirLancamentoService.getTiposLancamento().subscribe(tipos => {
        this.tiposLancamento = tipos;
        this.preselecionarTipoAtual();
      });
    }
  }

  private preselecionarTipoAtual(): void {
    if (this.tipoIdInicial) {
      this.tipoLancamento = this.tiposLancamento.find(t => t.id === this.tipoIdInicial);
    }
  }

  public salvar(): void {
    if (!this.tipoLancamento) {
      this.messageService.showToastWarning('Selecione o tipo de lançamento.');
      return;
    }

    if (this.tipoIdInicial === this.tipoLancamento.id) {
      this.dialogRef.close(false);
      return;
    }

    this.transferirLancamentoService
      .alterarTipo(this.lancamentoIds, this.tipoLancamento.id, this.conciliacaoId)
      .subscribe(() => {
        const msg = this.lancamentoIds.length === 1
          ? 'Tipo alterado com sucesso'
          : `Tipo de ${this.lancamentoIds.length} lançamentos alterado com sucesso`;
        this.messageService.showToastSuccess(msg);
        this.dialogRef.close(true);
      });
  }
}
